<template>
  <span>{{ numResults }}</span>
</template>

<script>
export default {
  name: "SearchResultCount",
  props: {
    numResults: {
      type: Number,
      default: 0
    }
  }
};
</script>

<style>

</style>
